import React from 'react';
import PropTypes from 'prop-types';
import './index.scss';

export default function Overlay({ children, onOverlayClick }) {
  const onClick = (event) => {
    event.stopPropagation();
    event.preventDefault();

    onOverlayClick();
  };

  const overlayProps = {
    onClick,
  };

  return (
    <div
      className="overlay"
      {...overlayProps}
    >
      {children}
    </div>
  );
}

Overlay.defaultProps = {
  children: [],
  onOverlayClick: () => {},
};

Overlay.propTypes = {
  children: PropTypes.node,
  onOverlayClick: PropTypes.func,
};
